import React from 'react';
import getRandomClass from '../utils/getRandomStatusClass';

const StatusChip: React.FC<{ status?: string }> = ({ status }) => {
  if (!status) return null;
  return (
    <span className={`status-chip ${getRandomClass(status) || ''}`}>
      <i className="status-chip-dot" />
      {status}
    </span>
  );
};

export default StatusChip;
